const data = [
  {
    name: "JAN",
    2015: 4000,
    2016: 2344,
    2017: 2400,
    2018: 5673,
    2019: 2400,
    2020: 2400
  },
  {
    name: "FEB",
    2015: 4000,
    2016: 2400,
    2017: 4356,
    2018: 2400,
    2019: 2400,
    2020: 4000
  },
  {
    name: "MAR",
    2015: 4000,
    2016: 4523,
    2017: 4567,
    2018: 2400,
    2019: 2400,
    2020: 2234
  },
  {
    name: "APR",
    2015: 4000,
    2016: 2400,
    2017: 2345,
    2018: 2400,
    2019: 2400,
    2020: 3456
  },
  {
    name: "MAY",
    2015: 4000,
    2016: 2400,
    2017: 2400,
    2018: 4564,
    2019: 2400,
    2020: 2345
  },
  {
    name: "JUN",
    2015: 4000,
    2016: 2400,
    2017: 2400,
    2018: 2400,
    2019: 2400,
    2020: 7896
  },
  {
    name: "JUL",
    2015: 4000,
    2016: 2400,
    2017: 2400,
    2018: 2400,
    2019: 2400,
    2020: 2734
  },
  {
    name: "AUG",
    2015: 4000,
    2016: 2400,
    2017: 2400,
    2018: 2400,
    2019: 2400,
    2020: 7643
  },
  {
    name: "SEP",
    2015: 4000,
    2016: 2400,
    2017: 2400,
    2018: 2400,
    2019: 2400,
    2020: 2346
  },
  {
    name: "OCT",
    2015: 4000,
    2016: 2400,
    2017: 2400,
    2018: 2400,
    2019: 2400,
    2020: 2853
  },
  {
    name: "NOV",
    2015: 4000,
    2016: 2400,
    2017: 2400,
    2018: 2400,
    2019: 2400,
    2020: 9754
  },
  {
    name: "DEC",
    2015: 4000,
    2016: 2400,
    2017: 2400,
    2018: 2400,
    2019: 2400,
    2020: 4732
  }
];

const Quarterdata = [
  {
    name: "Q1",
    2021: 4000,
    2020: 2400,
    2019: 1000,
    2018: 1200,
    2017: 900,
    2016: 1500
  },
  {
    name: "Q2",
    2021: 3000,
    2020: 1398,
    2019: 1000,
    2018: 1200,
    2017: 900,
    2016: 1500
  },
  {
    name: "Q3",
    2021: 2000,
    2020: 9800,
    2019: 1000,
    2018: 1200,
    2017: 900,
    2016: 1500
  },
  {
    name: "Q4",
    2021: 2780,
    2020: 3908,
    2019: 1000,
    2018: 1200,
    2017: 900,
    2016: 1500
  }
];

const Halfdata = [
  {
    name: "H1",
    2021: 4000,
    2020: 2400,
    2019: 1000,
    2018: 1200,
    2017: 900,
    2016: 1500
  },
  {
    name: "H2",
    2021: 3000,
    2020: 1398,
    2019: 1000,
    2018: 1200,
    2017: 900,
    2016: 1500
  }
];

const YOYdata = [
  {
    name: "2015",
    value: 900,
    amt: 2400
  },
  {
    name: "2016",
    value: 1500,
    amt: 2210
  },
  {
    name: "2017",
    value: 900,
    amt: 2290
  },
  {
    name: "2018",
    value: 1200,
    amt: 2000
  },
  {
    name: "2019",
    value: 1000,
    amt: 2290
  },
  {
    name: "2020",
    value: 1508,
    amt: 2000
  }
];
const GEOCHANNEL = [
  {
    name: "GT",
    value: 0,
    guid: "3d9e14a5-c816-47ca-85d6-76176064ee4d",
    checked: false
  },
  {
    name: "MT",
    value: 0,
    guid: "261ae803-0149-4083-9127-da216a08da83",
    checked: false
  },
  {
    name: "eCommerce",
    value: 0,
    guid: "b8f8169b-f06f-445d-9283-5ff3b4bc0567",
    checked: false
  },
  {
    name: "National Accounts",
    value: 0,
    guid: "da736c32-4cde-4a56-a777-15a267715f90",
    checked: false
  },
  {
    name: "RTM",
    value: 0,
    guid: "8d29bfdc-8457-4d22-8aa8-bc891795bb6e",
    checked: false
  }
];
const AREAGRAPH = [
  {
    name: "WEEK1",
    forecast: 123,
    actual: 345
  },
  {
    name: "WEEK2",
    forecast: 234,
    actual: 567
  },
  {
    name: "WEEK3",
    forecast: 345,
    actual: 764
  },
  {
    name: "WEEK4",
    forecast: 567,
    actual: 234
  },
  {
    name: "WEEK5",
    forecast: 789,
    actual: 678
  },
  {
    name: "WEEK6",
    forecast: 567,
    actual: 890
  },
  {
    name: "WEEK7",
    forecast: 456,
    actual: 678
  },
  {
    name: "WEEK8",
    forecast: 675,
    actual: 345
  },
  {
    name: "WEEK9",
    forecast: 234,
    actual: 565
  },
  {
    name: "WEEK10",
    forecast: 879,
    actual: 346
  },
  {
    name: "WEEK11",
    forecast: 786,
    actual: 456
  },
  {
    name: "WEEK12",
    forecast: 345,
    actual: 789
  }
];

const FD_AREAGRAPH = [
  {
    name: "wk1",
    forecast: 123,
    actual: 345
  },
  {
    name: "wk2",
    forecast: 234,
    actual: 567
  },
  {
    name: "wk3",
    forecast: 345,
    actual: 764
  },
  {
    name: "wk4",
    forecast: 567,
    actual: 234
  },
  {
    name: "wk5",
    forecast: 789,
    actual: 678
  },
  {
    name: "wk6",
    forecast: 567,
    actual: 890
  },
  {
    name: "wk7",
    forecast: 456,
    actual: 678
  },
  {
    name: "wk8",
    forecast: 675,
    actual: 345
  },
  {
    name: "wk9",
    forecast: 234,
    actual: 565
  },
  {
    name: "wk10",
    forecast: 879,
    actual: 346
  },
  {
    name: "wk11",
    forecast: 786,
    actual: 456
  },
  {
    name: "wk12",
    forecast: 345,
    actual: 789
  },
  {
    name: "wk13",
    forecast: 123,
    actual: 345
  },
  {
    name: "wk14",
    forecast: 234,
    actual: 567
  },
  {
    name: "wk15",
    forecast: 345,
    actual: 764
  },
  {
    name: "wk16",
    forecast: 567,
    actual: 234
  },
  {
    name: "wk17",
    forecast: 789,
    actual: 678
  },
  {
    name: "wk18",
    forecast: 567,
    actual: 890
  },
  {
    name: "wk19",
    forecast: 456,
    actual: 678
  },
  {
    name: "wk20",
    forecast: 675,
    actual: 345
  },
  {
    name: "wk21",
    forecast: 234,
    actual: 565
  },
  {
    name: "wk22",
    forecast: 879,
    actual: 346
  },
  {
    name: "wk23",
    forecast: 786,
    actual: 456
  },
  {
    name: "wk24",
    forecast: 345,
    actual: 789
  },
  {
    name: "wk25",
    forecast: 123,
    actual: 345
  },
  {
    name: "wk26",
    forecast: 234,
    actual: 567
  },
  {
    name: "wk27",
    forecast: 345,
    actual: 764
  },
  {
    name: "wk28",
    forecast: 567,
    actual: 234
  },
  {
    name: "wk29",
    forecast: 789,
    actual: 678
  },
  {
    name: "wk30",
    forecast: 567,
    actual: 890
  },
  {
    name: "wk31",
    forecast: 456,
    actual: 678
  },
  {
    name: "wk32",
    forecast: 675,
    actual: 345
  },
  {
    name: "wk33",
    forecast: 234,
    actual: 565
  },
  {
    name: "wk34",
    forecast: 879,
    actual: 346
  },
  {
    name: "wk35",
    forecast: 786,
    actual: 456
  },
  {
    name: "wk36",
    forecast: 345,
    actual: 789
  },
  {
    name: "wk37",
    forecast: 234,
    actual: 565
  },
  {
    name: "wk38",
    forecast: 879,
    actual: 346
  },
  {
    name: "wk39",
    forecast: 786,
    actual: 456
  },
  {
    name: "wk40",
    forecast: 345,
    actual: 789
  },
  {
    name: "wk41",
    forecast: 123,
    actual: 345
  },
  {
    name: "wk42",
    forecast: 234,
    actual: 567
  },
  {
    name: "wk43",
    forecast: 345,
    actual: 764
  },
  {
    name: "wk44",
    forecast: 567,
    actual: 234
  },
  {
    name: "wk45",
    forecast: 789,
    actual: 678
  },
  {
    name: "wk46",
    forecast: 567,
    actual: 890
  },
  {
    name: "wk47",
    forecast: 456,
    actual: 678
  },
  {
    name: "wk48",
    forecast: 675,
    actual: 345
  },
  {
    name: "wk49",
    forecast: 234,
    actual: 565
  },
  {
    name: "wk50",
    forecast: 879,
    actual: 346
  },
  {
    name: "wk51",
    forecast: 786,
    actual: 456
  },
  {
    name: "wk52",
    forecast: 345,
    actual: 789
  }
];

const FD_AREAGRAPH_MONTHS = [
  {
    name: "JAN",
    forecast: 123,
    actual: 345
  },
  {
    name: "FEB",
    forecast: 234,
    actual: 567
  },
  {
    name: "MAR",
    forecast: 345,
    actual: 764
  },
  {
    name: "APR",
    forecast: 567,
    actual: 234
  },
  {
    name: "MAY",
    forecast: 789,
    actual: 678
  },
  {
    name: "JUN",
    forecast: 567,
    actual: 890
  },
  {
    name: "JUL",
    forecast: 456,
    actual: 678
  },
  {
    name: "AUG",
    forecast: 675,
    actual: 345
  },
  {
    name: "SEP",
    forecast: 234,
    actual: 565
  },
  {
    name: "OCT",
    forecast: 879,
    actual: 346
  },
  {
    name: "NOV",
    forecast: 786,
    actual: 456
  },
  {
    name: "DEV",
    forecast: 586,
    actual: 956
  }
];
const COLOR = [
  "#023e7d",
  "#e57d2f",
  "#fca311",
  "#0353a4",
  "#63993d",
  "#4b9793",
  "8864FD"
];

const WEEK_NO = [
  {
    label: "WK 1",
    value: '01',
    JC_Month: 1,
    label2: "W1"
  },
  {
    label: "WK 2",
    value: '02',
    JC_Month: 1,
    label2: "W2"
  },
  {
    label: "WK 3",
    value: '03',
    JC_Month: 1,
    label2: "W3"
  },
  {
    label: "WK 4",
    value: '04',
    JC_Month: 1,
    label2: "W4"
  },
  {
    label: "WK 5",
    value: '05',
    JC_Month: 1,
    label2: "W5"
  },
  {
    label: "WK 6",
    value: '06',
    JC_Month: 2,
    label2: "W6"
  },
  {
    label: "WK 7",
    value: '07',
    JC_Month: 2,
    label2: "W7"
  },
  {
    label: "WK 8",
    value: '08',
    JC_Month: 2,
    label2: "W8"
  },
  {
    label: "WK 9",
    value: '09',
    JC_Month: 2,
    label2: "W9"
  },
  {
    label: "WK 10",
    value: '10',
    JC_Month: 3,
    label2: "W10"
  },
  {
    label: "WK 11",
    value: '11',
    JC_Month: 3,
    label2: "W11"
  },
  {
    label: "WK 12",
    value: '12',
    JC_Month: 3,
    label2: "W12"
  },
  {
    label: "WK 13",
    value: '13',
    JC_Month: 3,
    label2: "W13"
  },
  {
    label: "WK 14",
    value: '14',
    JC_Month: 4,
    label2: "W14"
  },
  {
    label: "WK 15",
    value: '15',
    JC_Month: 4,
    label2: "W15"
  },
  {
    label: "WK 16",
    value: '16',
    JC_Month: 4,
    label2: "W16"
  },
  {
    label: "WK 17",
    value: '17',
    JC_Month: 4,
    label2: "W17"
  },
  {
    label: "WK 18",
    value: '18',
    JC_Month: 4,
    label2: "W18"
  },
  {
    label: "WK 19",
    value: '19',
    JC_Month: 5,
    label2: "W19"
  },
  {
    label: "WK 20",
    value: '20',
    JC_Month: 5,
    label2: "W20"
  },
  {
    label: "WK 21",
    value: '21',
    JC_Month: 5,
    label2: "W21"
  },
  {
    label: "WK 22",
    value: '22',
    JC_Month: 5,
    label2: "W22"
  },
  {
    label: "WK 23",
    value: '23',
    JC_Month: 6,
    label2: "W23"
  },
  {
    label: "WK 24",
    value: '24',
    JC_Month: 6,
    label2: "W24"
  },
  {
    label: "WK 25",
    value: '25',
    JC_Month: 6,
    label2: "W25"
  },
  {
    label: "WK 26",
    value: '26',
    JC_Month: 6,
    label2: "W26"
  },
  {
    label: "WK 27",
    value: '27',
    JC_Month: 7,
    label2: "W27"
  },
  {
    label: "WK 28",
    value: '28',
    JC_Month: 7,
    label2: "W28"
  },
  {
    label: "WK 29",
    value: '29',
    JC_Month: 7,
    label2: "W29"
  },
  {
    label: "WK 30",
    value: '30',
    JC_Month: 7,
    label2: "W30"
  },
  {
    label: "WK 31",
    value: '31',
    JC_Month: 7,
    label2: "W31"
  },
  {
    label: "WK 32",
    value: '32',
    JC_Month: 8,
    label2: "W32"
  },
  {
    label: "WK 33",
    value: '33',
    JC_Month: 8,
    label2: "W33"
  },
  {
    label: "WK 34",
    value: '34',
    JC_Month: 8,
    label2: "W34"
  },
  {
    label: "WK 35",
    value: '35',
    JC_Month: 8,
    label2: "W35"
  },
  {
    label: "WK 36",
    value: '36',
    JC_Month: 9,
    label2: "W36"
  },
  {
    label: "WK 37",
    value: '37',
    JC_Month: 9,
    label2: "W37"
  },
  {
    label: "WK 38",
    value: '38',
    JC_Month: 9,
    label2: "W38"
  },
  {
    label: "WK 39",
    value: '39',
    JC_Month: 9,
    label2: "W39"
  },
  {
    label: "WK 40",
    value: '40',
    JC_Month: 10,
    label2: "W40"
  },
  {
    label: "WK 41",
    value: '41',
    JC_Month: 10,
    label2: "W41"
  },
  {
    label: "WK 42",
    value: '42',
    JC_Month: 10,
    label2: "W42"
  },
  {
    label: "WK 43",
    value: '43',
    JC_Month: 10,
    label2: "W43"
  },
  {
    label: "WK 44",
    value: '44',
    JC_Month: 10,
    label2: "W44"
  },
  {
    label: "WK 45",
    value: '45',
    JC_Month: 11,
    label2: "W45"
  },
  {
    label: "WK 46",
    value: '46',
    JC_Month: 11,
    label2: "W46"
  },
  {
    label: "WK 47",
    value: '47',
    JC_Month: 11,
    label2: "W47"
  },
  {
    label: "WK 48",
    value: '48',
    JC_Month: 11,
    label2: "W48"
  },
  {
    label: "WK 49",
    value: '49',
    JC_Month: 12,
    label2: "W49"
  },
  {
    label: "WK 50",
    value: '50',
    JC_Month: 12,
    label2: "W50"
  },
  {
    label: "WK 51",
    value: '51',
    JC_Month: 12,
    label2: "W51"
  },
  {
    label: "WK 52",
    value: '52',
    JC_Month: 12,
    label2: "W52"
  }
];

const YEARS = [
  {
    label: 2020,
    value: 2020
  },
  {
    label: 2021,
    value: 2021
  }
];

const YEARSPreVsPostOpso = [
  {
    label: 2016,
    value: 2016,
    checked: false,
    topBottomChecked: false,
    dtts: false,
    gtmtChecked: false,
    MCTcheckedTo: false,
    MCTcheckedFrom: false
  },
  {
    label: 2017,
    value: 2017,
    checked: false,
    topBottomChecked: false,
    dtts: false,
    gtmtChecked: false,
    MCTcheckedTo: false,
    MCTcheckedFrom: false
  },
  {
    label: 2018,
    value: 2018,
    checked: false,
    topBottomChecked: false,
    dtts: false,
    gtmtChecked: false,
    MCTcheckedTo: false,
    MCTcheckedFrom: false
  },
  {
    label: 2019,
    value: 2019,
    checked: false,
    topBottomChecked: false,
    dtts: false,
    gtmtChecked: false,
    MCTcheckedTo: false,
    MCTcheckedFrom: false
  },
  {
    label: 2020,
    value: 2020,
    checked: false,
    topBottomChecked: false,
    dtts: false,
    gtmtChecked: false,
    MCTcheckedTo: false,
    MCTcheckedFrom: false
  },
  {
    label: 2021,
    value: 2021,
    checked: false,
    topBottomChecked: false,
    dtts: false,
    gtmtChecked: false,
    MCTcheckedTo: false,
    MCTcheckedFrom: false
  }
];

const ACTIVITY_STATUS = [
  {
    label: "Draft",
    value: "draft"
  },
  {
    label: "Submitted By Acom",
    value: "submit_by_acom"
  },
  {
    label: "Approved By CDF",
    value: "approve_by_cdf"
  },
  {
    label: "Rejected By CDF",
    value: "reject_by_cdf"
  },
  {
    label: "Sent Back By CDF",
    value: "sendback_by_cdf"
  },
  {
    label: "Approved By CDFM",
    value: "approve_by_cdfm"
  },
  {
    label: "Rejected By CDFM",
    value: "reject_by_cdfm"
  },
  {
    label: "Sent Back By CDFM",
    value: "sendback_by_cdfm"
  },
  {
    label: "Approved By CMD",
    value: "approve_by_cmd"
  },
  {
    label: "Rejected By CMD",
    value: "reject_by_cmd"
  },
  {
    label: "Sent Back By CMD",
    value: "sendback_by_cmd"
  }
];

const QUARTER = [
  {
    label: "Quarter 1",
    value: 1
  },
  {
    label: "Quarter 2",
    value: 2
  },
  {
    label: "Quarter 3",
    value: 3
  },
  {
    label: "Quarter 4",
    value: 4
  }
];

const QUARTER_MONTHS = [
  {
    name: "JAN",
    value: 1,
    quarter: 1,
    checked: false,
    gtmtChecked: false,
    MCTcheckedTo: false,
    MCTcheckedFrom: false,
    topBottomChecked: false
  },
  {
    name: "FEB",
    value: 2,
    quarter: 1,
    checked: false,
    gtmtChecked: false,
    MCTcheckedTo: false,
    MCTcheckedFrom: false,
    topBottomChecked: false
  },
  {
    name: "MAR",
    value: 3,
    quarter: 1,
    checked: false,
    gtmtChecked: false,
    MCTcheckedTo: false,
    MCTcheckedFrom: false,
    topBottomChecked: false
  },
  {
    name: "APR",
    value: 4,
    quarter: 2,
    checked: false,
    gtmtChecked: false,
    MCTcheckedTo: false,
    MCTcheckedFrom: false,
    topBottomChecked: false
  },
  {
    name: "MAY",
    value: 5,
    quarter: 2,
    checked: false,
    gtmtChecked: false,
    MCTcheckedTo: false,
    MCTcheckedFrom: false,
    topBottomChecked: false
  },
  {
    name: "JUN",
    value: 6,
    quarter: 2,
    checked: false,
    gtmtChecked: false,
    MCTcheckedTo: false,
    MCTcheckedFrom: false,
    topBottomChecked: false
  },
  {
    name: "JUL",
    value: 7,
    quarter: 3,
    checked: false,
    gtmtChecked: false,
    MCTcheckedTo: false,
    MCTcheckedFrom: false,
    topBottomChecked: false
  },
  {
    name: "AUG",
    value: 8,
    quarter: 3,
    checked: false,
    gtmtChecked: false,
    MCTcheckedTo: false,
    MCTcheckedFrom: false,
    topBottomChecked: false
  },
  {
    name: "SEP",
    value: 9,
    quarter: 3,
    checked: false,
    gtmtChecked: false,
    MCTcheckedTo: false,
    MCTcheckedFrom: false,
    topBottomChecked: false
  },
  {
    name: "OCT",
    value: 10,
    quarter: 4,
    checked: false,
    gtmtChecked: false,
    MCTcheckedTo: false,
    MCTcheckedFrom: false,
    topBottomChecked: false
  },
  {
    name: "NOV",
    value: 11,
    quarter: 4,
    checked: false,
    gtmtChecked: false,
    MCTcheckedTo: false,
    MCTcheckedFrom: false,
    topBottomChecked: false
  },
  {
    name: "DEC",
    value: 12,
    quarter: 4,
    checked: false,
    gtmtChecked: false,
    MCTcheckedTo: false,
    MCTcheckedFrom: false,
    topBottomChecked: false
  }
];

const PROMO_TYPES = [
  {
    guid: "9263860e-1fe7-4e7c-aa7b-4da4f98f7def",
    Label: "TPR",
    checked: false,
    topActivitiesChecked: false,
    dtts: false,
    topBottomChecked: false
  },
  {
    guid: "7ea427b0-5ec2-44a1-b0e7-b9a82c0bd60a",
    Label: "EDLP",
    checked: false,
    topActivitiesChecked: false,
    dtts: false,
    topBottomChecked: false
  },
  {
    guid: "137c2b2d-c068-44f6-b1d1-8cd0eda535e5",
    Label: "SBB",
    checked: false,
    topActivitiesChecked: false,
    dtts: false,
    topBottomChecked: false
  },
  {
    guid: "b0107ffd-5026-4011-bdc6-3bb2e5986332",
    Label: "Gifts",
    checked: false,
    topActivitiesChecked: false,
    dtts: false,
    topBottomChecked: false
  },
  {
    guid: "88a78f88-99fd-4095-bddf-30aebe350dcd",
    Label: "MTFTS",
    checked: false,
    topActivitiesChecked: false,
    dtts: false,
    topBottomChecked: false
  }
];

const DEMAND_PLANNER_TYPES = [
  {
    id: 0,
    label: 'Weekly'
  },
  {
    id: 1,
    label: 'Monthly'
  },
  {
    id: 2,
    label: 'Weekly (Greg)'
  },
  {
    id: 3,
    label: 'Monthly (Greg)'
  },
  {
    id: 4,
    label: 'MATs-Primary'
  },
  {
    id: 5,
    label: 'MATs-Secondary'
  },
  {
    id: 6,
    label: 'SKU MATs-Primary'
  },
  {
    id: 7,
    label: 'SKU MATs-Secondary'
  },
  {
    id: 8,
    label: 'YOY Analysis-Primary'
  },
  {
    id: 9,
    label: 'YOY Analysis-Secondary'
  }
]

const DATA = {
  data,
  Quarterdata,
  Halfdata,
  YOYdata,
  GEOCHANNEL,
  COLOR,
  AREAGRAPH,
  FD_AREAGRAPH,
  FD_AREAGRAPH_MONTHS,
  WEEK_NO,
  YEARS,
  ACTIVITY_STATUS,
  QUARTER,
  QUARTER_MONTHS,
  YEARSPreVsPostOpso,
  PROMO_TYPES,
  DEMAND_PLANNER_TYPES
};

export default DATA;
